import React from 'react';

import {
  DescriptionList,
  DescriptionItem,
  Typography,
} from '@gogame/components';
import { useNumberFormat } from '@gogame/intl-ts';

import TextWithInfo from '../TextWithInfo';

const Activity = ({ data }) => {
  const numberFormatter = useNumberFormat();

  return data?.subscribers ? (
    <DescriptionList disableGutters data={data}>
      <DescriptionItem
        label={'Subscribes'}
        field={'subscribers'}
        type={({ value }) => {
          return <Typography>{numberFormatter(value)}</Typography>;
        }}
      />
      <DescriptionItem label={'Views, min'} field={'views.min'} />
      <DescriptionItem label={'Views, max'} field={'views.max'} />
      <DescriptionItem
        label={'Concurrent viewers'}
        field={'concurrentViewers'}
        type={({ value }) => {
          return <Typography>{numberFormatter(value)}</Typography>;
        }}
      />
      <DescriptionItem
        label={'Target audience'}
        field={'targetAudience'}
        type={'percent'}
      />
      <DescriptionItem
        label={
          <TextWithInfo info={'Engagement rate'}>Engagement rate</TextWithInfo>
        }
        field={'rate'}
      />
    </DescriptionList>
  ) : (
    <Typography color={'textSecondary'}>No activity</Typography>
  );
};

export default Activity;
